module.exports = __webpack_public_path__ + "media/images/landing/header_one-ef16d22b3b733f3bd3fe75530b87442d.jpg";